// GA4 analytics + conversion events. No-op when REACT_APP_GA4_MEASUREMENT_ID is unset.
const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
let ready = false;

function gtag() {
  if (window.dataLayer) window.dataLayer.push(arguments);
}

export const initGA = () => {
  if (ready || !GA_ID || typeof window === 'undefined') return;
  ready = true;

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  gtag('js', new Date());
  // We send page_view manually on route changes (SPA).
  gtag('config', GA_ID, { send_page_view: false });

  // Global WhatsApp-click tracking across the whole app (no per-page edits).
  document.addEventListener('click', (e) => {
    const a = e.target && e.target.closest && e.target.closest('a[href], button[data-testid]');
    if (!a) return;
    const href = a.getAttribute && a.getAttribute('href') || '';
    if (/wa\.me|api\.whatsapp\.com|whatsapp\.com\/send/i.test(href)) {
      trackEvent('whatsapp_click', { link_url: href, source: window.location.pathname });
      return;
    }
    // Get Started / sign-up CTAs: links to /auth or buttons flagged as get-started.
    const testid = (a.getAttribute && a.getAttribute('data-testid')) || '';
    const isGetStarted = /(^|\/)auth(\/|$|\?)/.test(href) || /get-started|get_started/i.test(testid);
    if (isGetStarted) {
      trackEvent('cta_click', { cta: 'get_started', location: window.location.pathname });
    }
  }, { capture: true });
};

export const trackPageView = (path) => {
  if (!ready) return;
  gtag('event', 'page_view', { page_path: path, page_location: window.location.href, page_title: document.title });
};

export const trackEvent = (name, params = {}) => {
  if (!ready) return;
  gtag('event', name, params);
};

export const trackSignUp = (method = 'phone') => trackEvent('sign_up', { method });

export const trackSubscribe = (planLabel, planId, value, currency = 'USD') =>
  trackEvent('subscribe', { plan: planLabel, plan_id: planId, value, currency });

export const trackToolUse = (toolName, params = {}) =>
  trackEvent('tool_use', { tool: toolName, ...params });

// Fired when a user initiates Stripe checkout from the Upgrade page.
export const trackBeginCheckout = (planLabel, planId, value, currency = 'USD') =>
  trackEvent('begin_checkout', { plan: planLabel, plan_id: planId, value, currency });

// Free tool / content page -> WhatsApp Accounting product bridge click.
// Measures the "acquisition tool -> core product" step of the conversion funnel.
export const trackProductBridge = (intent, destination) =>
  trackEvent('product_bridge_click', {
    intent,
    destination,
    source: typeof window !== 'undefined' ? window.location.pathname : '',
  });

// CPA partner lead submit. No personal form data is sent to analytics —
// only the non-identifying partnership-interest category.
export const trackCpaPartnerLeadSubmit = (partnershipInterest) =>
  trackEvent('cpa_partner_lead_submit', { partnership_interest: partnershipInterest || 'unspecified' });
